export default __webpack_public_path__ + "static/media/oscer-pres-fatigue.e9f580ab.svg";